import {
  CELL_CLICKED,
  CLICK_OUTSIDE,
  COL_CLICKED,
  COL_ENTER_COMPLETE,
  COL_LEAVE_COMPLETE,
  COLS_CHANGED,
  IScaffoldAction,
  PREVIEW_COL_WIDTH_CHANGE,
  PREVIEW_ROW_HEIGHT_CHANGE,
  ROW_CLICKED,
  ROW_ENTER_COMPLETE,
  ROW_LEAVE_COMPLETE,
  ROWS_CHANGED,
  ScaffoldState,
  SELECTION_CHANGED,
  SET_DRAGGING,
} from "./interface";
import { scr_cellClicked } from "./scr_cellClicked";
import { scr_clickOutside } from "./scr_clickOutside";
import { scr_colClicked } from "./scr_colClicked";
import { scr_colEnterComplete } from "./scr_colEnterComplete";
import { scr_colLeaveComplete } from "./scr_colLeaveComplete";
import { scr_colsChanged } from "./scr_colsChanged";
import { scr_previewColWidthChange } from "./scr_previewColWidthChange";
import { scr_previewRowHeightChange } from "./scr_previewRowHeightChange";
import { scr_rowClicked } from "./scr_rowClicked";
import { scr_rowEnterComplete } from "./scr_rowEnterComplete";
import { scr_rowLeaveComplete } from "./scr_rowLeaveComplete";
import { scr_rowsChanged } from "./scr_rowsChanged";
import { scr_selectionChanged } from "./scr_selectionChanged";
import { scr_setDragging } from "./scr_setDragging";

/**
 * Reducer for scaffold internal state transitions.
 * Delegates each action to the corresponding scr_ handler function.
 *
 * @param state - The current scaffold state.
 * @param action - The action describing the change to apply.
 * @returns The updated scaffold state after applying the action.
 */
export const scaffoldReducer = <T>(
  state: ScaffoldState<T>,
  action: IScaffoldAction<T>,
): ScaffoldState<T> => {
  switch (action.operation) {
    case SET_DRAGGING:
      return scr_setDragging(action, state);
    case COLS_CHANGED:
      return scr_colsChanged(action, state);
    case ROWS_CHANGED:
      return scr_rowsChanged(action, state);
    case COL_LEAVE_COMPLETE:
      return scr_colLeaveComplete(action, state);
    case COL_ENTER_COMPLETE:
      return scr_colEnterComplete(action, state);
    case ROW_LEAVE_COMPLETE:
      return scr_rowLeaveComplete(action, state);
    case ROW_ENTER_COMPLETE:
      return scr_rowEnterComplete(action, state);
    case PREVIEW_COL_WIDTH_CHANGE:
      return scr_previewColWidthChange(action, state);
    case PREVIEW_ROW_HEIGHT_CHANGE:
      return scr_previewRowHeightChange(action, state);
    case CELL_CLICKED:
      return scr_cellClicked(action, state);
    case ROW_CLICKED:
      return scr_rowClicked(action, state);
    case COL_CLICKED:
      return scr_colClicked(action, state);
    case CLICK_OUTSIDE:
      return scr_clickOutside(state);
    case SELECTION_CHANGED:
      return scr_selectionChanged(action, state);
  }
};
